import script from "./SfxFormSubmit.vue?vue&type=script&setup=true&lang=ts"
export * from "./SfxFormSubmit.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QPageContainer from 'quasar/src/components/page/QPageContainer.js';
import QPageSticky from 'quasar/src/components/page-sticky/QPageSticky.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QPageContainer,QPageSticky});
